import './App.css'
import './index.css'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom'
import Header from './component/header/Header'
import Home from './screen/home/Home'
import Footer from './component/footer/Footer'
import Flights from './screen/Flights/Flights'
import Hotels from './screen/Hotels/Hotels'
import Holidays from './screen/Holidays/Holidays'
import Visa from './screen/Visa/Visa'
import Insurance from './screen/Insurance/Insurance'
import Cabs from './screen/Cabs/Cabs'
import LandingPage from './component/LandingPage/LandingPage'
import AboutUs from './screen/AboutUs/AboutUs'
import Loader from './component/Loader/Loader'
import OurGoals from './component/OurGoals/OurGoals'
function App () {
  return (
    <Router>
      <div className='App'>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Flights' element={<Flights />} />
          <Route path='/Hotels' element={<Hotels />} />
          <Route path='/Holidays' element={<Holidays />} />
          <Route path='/Visa' element={<Visa />} />
          <Route path='/Insurance' element={<Insurance />} />
          <Route path='/Cabs' element={<Cabs />} />
          <Route path='/About' element={<AboutUs />} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
        <Loader />
        <OurGoals />
        <LandingPage />
        <Footer />
      </div>
    </Router>
  )
}

export default App
